riot.tag2('offer-raw-html', '<span></span>', '', '', function(opts) {
    this.on('mount', () => {
      this.root.innerHTML = this.opts.content;
    });

    this.on('update', () => {
      this.root.innerHTML = this.opts.content;
    });
});
